import { CommonSystemBridge } from '@lg/shared/for-apps'

export class FrontendSystemBridge extends CommonSystemBridge {}
